<template>
  <dialog-base v-show="isLoaded"
               show-close
               @close="close">
    <div class="mod-share">
      <img :src="poster"
           alt="">
      <div class="tip">
        长按海报-保存图片，邀请好友寻宝
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
import Maker from 'poster-maker'
import { random } from '@actly/core'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
      isLoaded: false,
      poster: '',
      num: 0,
      textMap: [
        {
          text: '“从长远看，大约90%的投资收益都是来自成功的资产配置。”',
          name: {
            text: '——加里·布林森',
            x: 434,
            y: 780
          }
        },
        {
          text: '时间投资价值就是“找到专业的公司，做时间的朋友”。'
        },
        {
          text: '人生就像滚雪球，最重要的是发现很湿的雪和很长的坡。',
          name: {
            text: '——沃伦·巴菲特',
            x: 434,
            y: 780
          }
        }
      ]
    }
  },
  async created() {
    this.$loading()
    const text = this.textMap[random(0, 2)]
    const maker = new Maker({
      width: 716,
      height: 1055,
      backgroundColor: '#fff'
    })
    await maker.putImg({
      img: require('@/assets/dialog/dialog-share.png'),
      x: 0,
      y: 0,
      width: 716,
      height: 1055
    })
    await maker.putImg({
      img: require('@/assets/dialog/dialog-share-map.jpg'),
      x: 66,
      y: 216,
      width: 582,
      height: 423
    })
    await maker.putParagraph({
      text: text.text,
      x: 78,
      y: 670,
      width: 546,
      lineHeight: 1.5,
      fontSize: 30,
      fontColor: '#FF9634'
    })
    if (text.name) {
      await maker.putText({
        text: text.name.text,
        x: text.name.x,
        y: text.name.y,
        fontSize: 30,
        fontColor: '#FF9634'
      })
    }
    await maker.putImg({
      img: require('@/assets/ico/ico-share-qrcode.png'),
      x: 528,
      y: 844,
      width: 106,
      height: 106
    })
    await maker.putText({
      text: '扫码寻宝赢红包',
      x: 502,
      y: 966,
      fontSize: 22,
      fontColor: '#FF9634'
    })
    await maker.putText({
      text: `您已找到${this.num}个宝物`,
      x: 184,
      y: 896,
      fontSize: 30,
      fontColor: '#882104'
    })

    this.poster = await maker.canvasToDataUrl()
    this.$toast.clear()
    this.isLoaded = true
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.mod-share {
  width: 716px;
  height: 1055px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .tip {
    margin-top: 25px;
    text-align: center;
    font-size: 28px;
    color: #ffeda7;
  }
}
</style>